import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProductReveal() {
  return <Section data-id="element-105">
      <FadeIn data-id="element-106">
        <div className="border border-warm-border rounded-2xl p-8 bg-white shadow-sm mb-16" data-id="element-107">
          <motion.div className="flex justify-center mb-8" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          ease: 'easeOut'
        }} data-id="element-108">
            <div className="relative" data-id="element-109">
              <div className="absolute inset-0 bg-accent-teal/5 rounded-2xl blur-2xl scale-110" data-id="element-110" />
              <img src="https://cdn.magicpatterns.com/uploads/5T2ckXm6hkFVhusVfURXAX/heylloyd-image-1770455569538.png" alt="Monotributista en Calma — Vista previa del ebook en tablet" className="relative w-64 md:w-80 h-auto drop-shadow-xl" data-id="element-111" />
            </div>
          </motion.div>

          <h2 className="text-2xl font-bold mb-2" data-id="element-112">Monotributista en Calma</h2>
          <p className="text-text-secondary mb-6 font-serif italic" data-id="element-113">
            (PDF + Plantillas)
          </p>

          <p className="text-lg mb-6" data-id="element-114">
            Un plan de 30 días para armar un sistema simple que te permita:
          </p>

          <ul className="space-y-3 mb-8" data-id="element-115">
            {['Pagar lo urgente sin destruir el mes siguiente', 'Dejar de sorprenderte con impuestos', 'Cortar fugas silenciosas', 'Empezar a desactivar la deuda sin atacar todo a la vez', 'Recuperar aire (y con eso, energía)'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-116">
                <Check className="w-5 h-5 text-accent-teal shrink-0 mt-1" data-id="element-117" />
                <span className="text-text-secondary" data-id="element-118">{item}</span>
              </li>)}
          </ul>

          <div className="inline-block bg-warm-highlight px-4 py-2 rounded-lg border border-warm-border" data-id="element-119">
            <span className="text-sm text-text-secondary uppercase tracking-wider font-medium mr-2" data-id="element-120">
              Precio:
            </span>
            <span className="text-xl font-bold text-text-primary" data-id="element-121">
              $6.360 ARS
            </span>
          </div>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-122">
        <div className="text-center mb-12" data-id="element-123">
          <p className="text-sm uppercase tracking-widest text-accent-warm font-bold mb-4" data-id="element-124">
            La idea central
          </p>
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-text-primary" data-id="element-125">
            Primero aire, después orgullo.
          </h2>
        </div>
      </FadeIn>

      <FadeIn delay={0.3} data-id="element-126">
        <p className="text-lg mb-6" data-id="element-127">
          Si hoy estás en rojo, "ahorrar fuerte" y "ponerte metas" suena lindo…
          pero te deja peor. Porque te obliga a una perfección imposible. Y
          cuando fallás, te castigás y abandonás.
        </p>
        <p className="text-lg mb-10 font-medium" data-id="element-128">Acá hacemos lo contrario:</p>
      </FadeIn>

      <div className="grid gap-4" data-id="element-129">
        {['Aseguramos lo mínimo para que tu cuerpo baje el pánico', 'Evitamos bombas (impuestos)', 'Cortamos el sangrado (deuda)', 'Recién ahí construimos futuro (micro, automático)'].map((step, i) => <FadeIn key={i} delay={0.4 + i * 0.1} data-id="element-130">
            <div className="flex items-center gap-4 p-4 bg-warm-section rounded-lg border border-warm-border" data-id="element-131">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-accent-teal text-white font-bold shrink-0" data-id="element-132">
                {i + 1}
              </span>
              <span className="text-lg text-text-primary" data-id="element-133">{step}</span>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
}